module.exports = "/_next/static/images/e3b3e10e53ef14cd72f938a249cd3ca2-credit-card-perks-xs-1x.png";